import { Injectable } from '@angular/core';
import { VueAppDefaultsService } from '@vue/vueframework';
import { AppConfigService } from './shared/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class AppDefaultsService extends VueAppDefaultsService {
  public constructor(
    public appConfigService: AppConfigService
  ) {
    super();
  }

  public getAuthenticatedDefaultState(): string | null {
    /**
     * Get our query params w/o injecting router using
     * legacy hash routing
     */

    const hash = window.location.hash.split('?')[ 1 ];
    const queryParams = new URLSearchParams(hash);
    const redirect = queryParams.get('redirect');
    if (redirect) {
      return decodeURIComponent(redirect);
    }
    return 'vue-id-check';
  }

  public getApplicationsUnAuthenticatedURLList(): string[] {
    return [
      'rest\/realms\/TESTCENTER\/users\/.+\/changePassword',
      'rest\/accountManagement\/TESTCENTER\/initiatepasswordreset',
      'rest\/accountManagement\/TESTCENTER\/securityquestions',
      'rest\/accountManagement\/TESTCENTER\/activate',
      'rest\/accountManagement\/TESTCENTER\/usersecurityquestions',
      'rest\/accountManagement\/TESTCENTER\/usernamelookup',
      '/rest\/accountManagement\/TESTCENTER\/usersecurityquestions\/validate',
      'rest\/accountManagement\/TESTCENTER\/password',
      'rest\/accountManagement\/TESTCENTER\/userlookup',
      'rest\/accountManagement\/TESTCENTER\/userPasswordResetDetails'
    ];
  }

  public getDefaultHelpURL(): string {
    if (this.appConfigService.getLocaleHelpLinkEnabled()) {
      const locale: string = this.appConfigService.getNormalizedLocale();
      return this.appConfigService.getWebHelpBaseURL() + locale + '/start.htm';
    }
    return this.appConfigService.getWebHelpUrl();
  }

  public getLocaleCookieName(): string {
    return 'CONNECT_LOCALE';
  }

  public getDefaultAppBundle(): string {
    return 'Connect';
  }

  public getLoginSiteIDRequired(): boolean {
    return true;
  }

  public getLoginRealm(): string {
    return 'TESTCENTER';
  }

  public getPortalRESTRoot(): string {
    sessionStorage.setItem('VUE-restBaseURL', this.appConfigService.getAPIUrl());
    return this.appConfigService.getAPIUrl();
  }

  public getApplicationRESTRoot(): string {
    return this.appConfigService.getAPIUrl();
  }

  public getXliffBaseURL(): string {
    return this.appConfigService.getXliffServicesUrl();
  }

  public getIsRestRootUsedForXliff(): boolean {
    return false;
  }

  public getLocalizationEnabled(): boolean {
    return true;
  }

  public getTestCenterServicesRESTRoot(): string {
    return this.appConfigService.getTestCenterServicesUrl();
  }

  public getPortalMessageBundle(): string {
    const portalContext = sessionStorage.getItem('portal-context');
    if (portalContext === null) {
      sessionStorage.setItem('portal-context', 'Connect');
      return 'Connect';
    }
    return portalContext;
  }

  public getCASRESTRoot(): string {
    return this.appConfigService.getCASUrl();
  }

  public getTedUrl(): string {
    return this.appConfigService.getTedUrl();
  }

  /**
   * This is needed after the change was made in VUEFramework to use the appId instead of menuEntryURI to authenticate
   * a route
   *
   * @return
   *    True if the application is not external.
   *    In our case our app has its own URL and it is external
   */
  public isPortalApplication(): boolean {
    return false;
  }

  /**
   * Connect is a portal app and should use its own login screen.
   */
  public isPortal(): boolean {
    return true;
  }

  public getXliffHostingType(): string {
    return 'cdn';
  }
}
